<template>
  <a
    class="frisbuy-sr-instagram"
    :class="[
      {
        'frisbuy-to-hide': isHide,
      },
      `hide-direction--${hideDirection}`,
    ]"
  >
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.5 12h-15C17.598 12 12 17.598 12 24.5v15C12 46.403 17.598 52 24.5 52h15C46.403 52 52 46.403 52 39.5v-15C52 17.598 46.403 12 39.5 12zm8.75 27.5c0 4.825-3.925 8.75-8.75 8.75h-15c-4.825 0-8.75-3.925-8.75-8.75v-15c0-4.825 3.925-8.75 8.75-8.75h15c4.825 0 8.75 3.925 8.75 8.75v15z"
        fill="url(#ca)"
      />
      <path
        d="M32 22c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm0 16.25A6.26 6.26 0 0 1 25.75 32 6.257 6.257 0 0 1 32 25.75 6.257 6.257 0 0 1 38.25 32 6.26 6.26 0 0 1 32 38.25z"
        fill="url(#cb)"
      />
      <path
        d="M42.75 22.582a1.333 1.333 0 1 0 0-2.665 1.333 1.333 0 0 0 0 2.665z"
        fill="url(#cc)"
      />
      <defs>
        <linearGradient
          id="ca"
          x1="15.662"
          y1="48.339"
          x2="48.338"
          y2="15.661"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFC107" />
          <stop offset=".507" stop-color="#F44336" />
          <stop offset=".99" stop-color="#9C27B0" />
        </linearGradient>
        <linearGradient
          id="cb"
          x1="24.929"
          y1="39.071"
          x2="39.071"
          y2="24.929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFC107" />
          <stop offset=".507" stop-color="#F44336" />
          <stop offset=".99" stop-color="#9C27B0" />
        </linearGradient>
        <linearGradient
          id="cc"
          x1="41.808"
          y1="22.192"
          x2="43.692"
          y2="20.308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFC107" />
          <stop offset=".507" stop-color="#F44336" />
          <stop offset=".99" stop-color="#9C27B0" />
        </linearGradient>
      </defs>
    </svg>
  </a>
</template>

<style scoped lang="scss">
.frisbuy-sr-instagram {
  flex-shrink: 0;
  top: 8px;
  left: 8px;
  transition: opacity 0.2s, transform 0.3s, height 0.2s;

  &.frisbuy-to-hide {
    opacity: 0;
    height: 0;
    pointer-events: none;

    &.hide-direction--top {
      transform: translateY(-100%);
    }
    &.hide-direction--right {
      transform: translateX(100%);
    }
    &.hide-direction--bottom {
      transform: translateY(100%);
    }
    &.hide-direction--left {
      transform: translateX(-100%);
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      displayInstagramIcon: !this.isHide,
    };
  },

  props: {
    isHide: {
      type: Boolean,
      require: false,
      default: false,
    },

    hideDirection: {
      type: String,
      require: false,
      default: "none",
      validator(value) {
        return ["none", "top", "right", "bottom", "left"].includes(value);
      },
    },
  },
};
</script>
